export var min = function min(array) {
  return Math.min.apply(Math, array);
};
export var max = function max(array) {
  return Math.max.apply(Math, array);
};
export var round = function round(value, step) {
  if (step === void 0) {
    step = 1.0;
  }

  var inv = 1.0 / step;
  return Math.round(value * inv) / inv;
};
export var floor = function floor(value, step) {
  if (step === void 0) {
    step = 1.0;
  }

  var inv = 1.0 / step;
  return Math.floor(value * inv) / inv;
};
export var ceil = function ceil(value, step) {
  if (step === void 0) {
    step = 1.0;
  }

  var inv = 1.0 / step;
  return Math.ceil(value * inv) / inv;
};